module.exports = __webpack_public_path__ + "img/red-pita-05.baed1129.png";